import 'core-js/stable'; // Provides base polyfills and workaround for IE

import './libraries/slimmageSettings';
import './libraries/slimmage';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';

// import AVGController from './controllers/avg';
import ConsentController from '@humandigital-agency/consent-controller';

import HeaderSearchController from './controllers/search/headerSearch';
import FormController from './controllers/form';
import ToastController from './controllers/toast/controller';
import SliderController from './controllers/slider';
import GalleryController from './controllers/gallery';
import ShoppingCartController from './controllers/shoppingCart/controller';
// import HyphenController from './controllers/hyphen';
import AccordeonController from './controllers/accordeon/controller';
import DiptychController from './controllers/diptych';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
    
        app.polyfillController = polyfills;
    
        // app.AVGController = new AVGController();
        app.ConsentController = new ConsentController();
        app.HeaderController = new HeaderController();
        app.HeaderSearchController = new HeaderSearchController();
        app.MediaController = new MediaController();
        app.FormController = new FormController();
        app.ToastController = new ToastController();
        app.SliderController = new SliderController();
        app.GalleryController = new GalleryController();
        app.ShoppingCartController = new ShoppingCartController();
        // app.HyphenController = new HyphenController();
        app.accordeonController = new AccordeonController();
        app.diptychController = new DiptychController();

        // Modules
        if (document.querySelector('.shareContainer')) {
            import( /* webpackChunkName: "modules/share" */ './controllers/share/controller').then(e => {
                app.shareController = new e.default();
            });
        }

        if (document.querySelector('.blSendStory')) {
            import( /* webpackChunkName: "modules/storySubmission" */ './controllers/storySubmission').then(e => {
                app.storySubmissionController = new e.default();
            });
        }

        if (document.querySelector('.blSendActivity')) {
            import( /* webpackChunkName: "modules/activitySubmission" */ './controllers/activitySubmission').then(e => {
                app.activitySubmissionController = new e.default();
            });
        }

        if (document.querySelector('.readMoreContainer')) {
            import( /* webpackChunkName: "modules/readMore" */ './controllers/readMore/controller').then(e => {
                app.readMoreController = new e.default();
            });
        }

        if (document.querySelector('.activityOverview')) {
            import( /* webpackChunkName: "modules/overview" */ './overview/newController').then(e => {
                app.overviewController = new e.default();
            });
        }

        if (document.querySelector('.blLocationData')) {
            import( /* webpackChunkName: "modules/locationBlock" */ './controllers/locationBlock/controller').then(e => {
                app.locationBlockController = new e.default();
            });
        }

        if (document.querySelector('.blRoute')) {
            import( /* webpackChunkName: "modules/routeBlock" */ './controllers/routeBlock/controller').then(e => {
                app.routeBlockController = new e.default();
            });
        }

        if (document.querySelector('.blTimeline .timeline')) {
            import( /* webpackChunkName: "modules/timeline" */ './controllers/timeline/controller').then(e => {
                app.timelineController = new e.default();
            });
        }

        if (document.querySelector('.interactiveRegionChart')) {
            import( /* webpackChunkName: "modules/regionChart" */ './controllers/regionChart/controller').then(e => {
                app.regionChartController = new e.default();
            });
        }

        if (document.querySelector('.blAudio .audioBlock')) {
            import( /* webpackChunkName: "modules/audio" */ './controllers/audioBlock/controller').then(e => {
                app.audioBlockController = new e.default();
            });
        }

        if (document.querySelector('.blPoIImage')) {
            import( /* webpackChunkName: "modules/pointsOfInterest" */ './controllers/pointsOfInterest/controller').then(e => {
                app.pointsOfInterestController = new e.default();
            });
        }

        if (document.querySelector('[data-add-to-calendar]')) {
            import( /* webpackChunkName: "modules/addToCalendar" */ './controllers/addToCalendar').then(e => {
                app.addToCalendarController = new e.default();
            });
        }

        await app.init();
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');

})();